import React, { useState, useEffect, forwardRef } from "react";
import ttAPI from '../../api/ttAPI';
import { Button } from '../../components/Wrappers'
import { Grid, Box, CircularProgress, TextField, InputAdornment, FormControl, InputLabel, NativeSelect} from "@material-ui/core";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import {DropzoneArea} from 'material-ui-dropzone'

// Icons
import {
    CalendarToday as CalendarTodayIcon,
    Publish as PublishIcon
} from '@material-ui/icons'

import SelectJob from '../../components/Upload/SelectJob';
import SelectAccount from '../../components/Upload/SelectAccount';

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import classnames from "classnames";
import "./Upload.css";

registerLocale('en-NZ', enNZ);

const Upload = forwardRef((props, ref) => {
    var classes = useStyles();

    const [isUploading, setIsUploading] = useState(false);
    const [fileObjects, setFileObjects] = useState([]);
    const [jobId, setJobId] = useState(undefined);
    const [userId, setUserId] = useState(undefined);
    const [selectedFrom, setSelectedFrom] = React.useState(null);
    const [fromFocused, setFromFocused] = React.useState(false);
    const [selectedTo, setSelectedTo] = React.useState(null);
    const [toFocused, setToFocused] = React.useState(false);
    var currentFromValue = null;
    var currentToValue = null;
    const [selectedIsAll, setSelectedIsAll] = React.useState('YES');

    useEffect(() => {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
      setSelectedFrom(firstDay);
      setSelectedTo(lastDay);
    },[]);

    const onUpload = async () => {
        setIsUploading(true);
        if ( window.FileReader && window.FormData) {
           var formData = new FormData();
           var reader = new FileReader();
           // read
           reader.onload = async function(e) {
               var fileName = fileObjects[0].name;
               if (formData) {console.log(fileObjects[0]);
                   formData.append('files[]', fileObjects[0], fileName);

                   var from = selectedFrom;
                   var to = selectedTo;

                   if (from === undefined || from === null || to === undefined || to === null) {
                       var date = new Date()
                       var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                       var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
                       from = firstDay;
                       to = lastDay;
                   }

                   let [f_date, f_month, f_year] = from.toLocaleDateString('en-NZ').split("/");
                   let [t_date, t_month, t_year] = to.toLocaleDateString('en-NZ').split("/");

                   const response = await ttAPI.uploadMetrelResults(jobId, userId, `${f_year}-${f_month}-${f_date}`, `${t_year}-${t_month}-${t_date}`, selectedIsAll === 'NO', formData);
                   setIsUploading(false);
                   if (response) {
                     sendNotification('success', 'Success - Metrel Results Uploaded. The server will take sometime to process all the records. ', classes);
                   }
                   else {
                     sendNotification('error', 'Error - Error Metrel Results.', classes);
                   }
               }

           };
           reader.readAsDataURL(fileObjects[0]);
       }

    }

    function onJobSelected(job) {
      if (job !== undefined && job !== null) {
          setJobId(job.id);
      }
      else {
          setJobId(undefined);
      }
    }

    function onAccountSelected(account) {console.log(account)
      if (account !== undefined && account !== null) {
          setUserId(account.id);
      }
      else {
          setUserId(undefined);
      }
    }

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeFrom(d) {//console.log(d);
      currentFromValue = d;
    }

    function handleChangeTo(d) {
      currentToValue = d;
    }

    function onFocusFrom(event) {
      setFromFocused(true);
    }

    function onFocusTo(event) {
      setToFocused(true);
    }

    function blurFrom(event) {
      setFromFocused(false);
    }

    function blurTo(event) {
      setToFocused(false);
    }

    function handleSelectFrom(d) {
      setSelectedFrom(d);
    }

    function handleSelectTo(d) {
      setSelectedTo(d);
    }

    // triggered if use keyboard
    function handleFromKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setFromFocused(false);
      }
    }

    function handleToKeyPress(event) {
      if (event.which === 9 || event.which === 13 || event.which === 27) {
        setToFocused(false);
      }
    }

    function handleChangeIsAll(e) {
      setSelectedIsAll(e.target.value);
    }


    return (
      <>
        <PageTitle title="Upload Metrel Data File" />
        <Grid container spacing={8}>
          <Grid item xs={12} md={12} lg={12}>
          <Widget
            title=""
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
            disableWidgetMenu
            showOverflow
          >
            <div style={{marginBottom: '20px'}}>
                <SelectJob labelName="Search Open Job" onSelect={onJobSelected}/>
            </div>

            <div style={{marginBottom: '20px'}}>
                <SelectAccount labelName="Search User" onSelect={onAccountSelected}/>
            </div>

            <FormControl variant="outlined" style={{marginBottom: '20px', width: '100%'}} className={classnames({
                  'import-all-select-control': true
                })}>
              <InputLabel id="is_all">Import All?</InputLabel>
              <div className={classnames({
                            'select-control-input': true
                          })}>
                <NativeSelect
                  value={selectedIsAll}
                  onChange={handleChangeIsAll}
                >
                   <option value="YES">YES</option>
                   <option value="NO">NO</option>
                </NativeSelect>
              </div>
            </FormControl>

            {selectedIsAll === 'NO' &&

              <div className={classes.uploadCalendars}>
                  <TextField
                    id="from"
                    label="From"
                    className={classnames({
                    'textField': true,
                    'reportCalendarField': true,
                    [classes.calendarFocused]: fromFocused
                  })}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                        inputComponent: () =>
                        <DatePicker
                        className={classes.textField}
                        selected={selectedFrom}
                        onChange={handleChangeFrom}
                        onFocus={onFocusFrom}
                        onSelect={handleSelectFrom}
                        onClickOutside={blurFrom}
                        onKeyDown={handleFromKeyPress}
                        locale="en-NZ"
                        timeIntervals={30}
                        dateFormat="dd/MM/yyyy"
                        />
                      }}
                  />
                  <TextField
                    id="to"
                    label="To"
                    className={classnames({
                    'textField': true,
                    'reportCalendarField': true,
                    [classes.calendarFocused]: toFocused
                  })}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      startAdornment: (
                          <InputAdornment position="start">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                        inputComponent: () =>
                        <DatePicker
                        className={classes.textField}
                        selected={selectedTo}
                        onChange={handleChangeTo}
                        onFocus={onFocusTo}
                        onSelect={handleSelectTo}
                        onClickOutside={blurTo}
                        onKeyDown={handleToKeyPress}
                        locale="en-NZ"
                        timeIntervals={30}
                        dateFormat="dd/MM/yyyy"
                        />
                      }}
                  />

              </div>
            }

            <div>
            <DropzoneArea
                      filesLimit={1}
                      showFileNames={true}
                      acceptedFiles={['.csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values']}
                      dropzoneText={"Drag and drop a Metrel results file here"}
                      onChange={ newFileObjs => {setFileObjects(newFileObjs); }}
                      onDelete={ newFileObjs => {setFileObjects([]); }}
                      maxFileSize={2097152}
                    />

                    {fileObjects !== undefined && fileObjects !== null &&
                      fileObjects.length > 0 &&
                      <Button onClick={onUpload} disabled={isUploading || (jobId === undefined || jobId === null || jobId <= 0 || userId === undefined || userId === null || userId <= 0 ||
                                                           (selectedIsAll === 'NO' ? (selectedTo === null || selectedTo === undefined || selectedTo === '' || selectedFrom === null || selectedFrom === undefined || selectedFrom === '') : false))}>
                        <Box>
                            <PublishIcon />
                        </Box>
                        {isUploading && <span><CircularProgress size={25}/> Uploading Metrel results file...</span>}
                        {!isUploading && <span>Upload Metrel Results</span>}
                    </Button>}
            </div>
            </Widget>
          </Grid>
        </Grid>
      </>
    );
});

export default Upload;
